import { Avatar, Button, Card, Flex, Heading, IconButton, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { FC } from 'react';

import ArrowLeftIcon from '@/assets/icons/ic-arrow-left.svg';

import { ChatProfile } from '@/components/ui/shared/chat/ChatPopup/components/types';

interface IBlockedUserScreen {
  setProfileSelected: (profile: ChatProfile | null) => void;
}

export const BlockedUserScreen: FC<IBlockedUserScreen> = ({ setProfileSelected }) => {
  return (
    <Flex h="full" w="full" px={{ base: 8, md: 5 }} py={6} flexDirection="column">
      <Flex w="full">
        <IconButton
          size="sm"
          onClick={() => setProfileSelected(null)}
          variant="unstyled"
          aria-label="Go back"
          icon={<ArrowLeftIcon />}
        />
        <Flex alignItems="center" ml={2}>
          <Avatar bg="gray.100" color="white" />
          <Text ml={4} fontWeight="bold" fontFamily="heading">
            User
          </Text>
        </Flex>
      </Flex>
      <Flex justifyContent="center" alignItems="center">
        <Card border="none" p={6} w="290px" mt={6} backgroundColor="gray.50">
          <Heading as="h1" fontSize="xl" fontWeight="bold" mb={2}>
            User blocked
          </Heading>
          <Text mt={4}>
            This user has been blocked, and your chat history has been deleted. You can unblock them anytime from&nbsp;
            <Button as={Link} target="_blank" rel="noopener noreferrer" href="/my-account/preferences" variant="link">
              your profile.
            </Button>
          </Text>
        </Card>
      </Flex>
    </Flex>
  );
};
